import { useCustomerConfig } from '../../utils/FetchConfig';
import { IBlurTextFieldProps } from './BlurTextField/BlurTextField';
import * as input from './inputComponents';
import { ConnectedLoqateModal } from '../../views/common/ConnectedLoqateModal';
import { What3WordsInput } from './What3WordsInput';
import React, { ComponentProps } from 'react';
import Field, { FieldProps } from './Field';
import Country from '../../graphql/entities/company/Country';

export const ConnectedAddress = ({
  dataid,
  readOnly,
  labelDefaults = { line1: 'Address' },
  labelOverrides = {},
  loqateProps,
  postCodeProps = {},
  onChangeField,
}: {
  dataid: string;
  readOnly?: boolean;
  labelDefaults?: {
    line1?: string;
  };
  labelOverrides?: {
    line1?: string;
    line2?: string;
    line3?: string;
    line4?: string;
    line5?: string;
  };
  loqateProps?: Partial<ComponentProps<typeof ConnectedLoqateModal>>;
  postCodeProps?: Partial<FieldProps<IBlurTextFieldProps>>;
  onChangeField?: (fieldName: string, value: string) => void;
}) => {
  const customerConfig = useCustomerConfig();

  return (
    <>
      <Field<IBlurTextFieldProps>
        dataid={`${dataid}.line1`}
        component={input.BlurTextField}
        label={labelOverrides.line1 ?? customerConfig?.addressLine1Label ?? labelDefaults.line1}
        inputSuffix={<ConnectedLoqateModal addressDataid={dataid} disabled={readOnly} {...loqateProps} />}
        readOnly={readOnly}
        enableOnChange={true}
        onChange={(event, newValue) => {
          onChangeField?.('line1', newValue);
        }}
      />
      <Field
        dataid={`${dataid}.line2`}
        component={input.BlurTextField}
        label={labelOverrides.line2 ?? customerConfig?.addressLine2Label ?? ''}
        readOnly={readOnly}
        enableOnChange={true}
        onChange={(event, newValue) => {
          onChangeField?.('line2', newValue);
        }}
      />
      <Field
        dataid={`${dataid}.line3`}
        component={input.BlurTextField}
        label={labelOverrides.line3 ?? customerConfig?.addressLine3Label ?? ''}
        readOnly={readOnly}
        enableOnChange={true}
        onChange={(event, newValue) => {
          onChangeField?.('line3', newValue);
        }}
      />
      <Field
        dataid={`${dataid}.line4`}
        component={input.BlurTextField}
        label={labelOverrides.line4 ?? customerConfig?.addressLine4Label ?? ''}
        readOnly={readOnly}
        enableOnChange={true}
        onChange={(event, newValue) => {
          onChangeField?.('line4', newValue);
        }}
      />
      <Field
        dataid={`${dataid}.line5`}
        component={input.BlurTextField}
        label={labelOverrides.line5 ?? customerConfig?.addressLine5Label ?? ''}
        readOnly={readOnly}
        enableOnChange={true}
        onChange={(event, newValue) => {
          onChangeField?.('line5', newValue);
        }}
      />
      <Field
        dataid={`${dataid}.postCode`}
        component={input.BlurTextField}
        label="Post Code"
        readOnly={readOnly}
        enableOnChange={true}
        onChange={(event, newValue) => {
          onChangeField?.('postCode', newValue);
        }}
        {...postCodeProps}
      />
      <Field
        dataid={`${dataid}.country`}
        component={input.Dropdown}
        label="Country"
        readOnly={readOnly}
        {...Country.dropdown}
        onChange={(event, newValue) => {
          onChangeField?.('country', newValue);
        }}
      />
      <Field
        dataid={`${dataid}.what3words`}
        component={What3WordsInput}
        label={'What 3 Words'}
        readOnly={readOnly}
        onChange={(event, newValue) => {
          onChangeField?.('what3words', newValue);
        }}
      />
    </>
  );
};
